function parseTrackingCheckpointLocation(_ref) {
  let {
    alpha2Code,
    state,
    zipCode,
    city,
    location,
    coordinates
  } = _ref;
  if (alpha2Code || state || zipCode || city) {
    const locationData = [city, state, zipCode, alpha2Code].filter(s => !!s);
    return locationData.join(', ');
  } else if (location) {
    return location;
  } else if (coordinates) {
    return `${coordinates.latitude}, ${coordinates.longitude}`;
  } else {
    return '';
  }
}

export { parseTrackingCheckpointLocation };
//# sourceMappingURL=TrackingLocationHelpers.js.map
